/* eslint-disable no-unused-vars */
import { OS_TYPE } from './magazine'

export interface ReqCreateNotification {
  schedule_at: string
  content: string
  os_type: any[]
  conditions_day?: number
  condition?: number
  app_id: number
}

export enum ConditionDevice {
  NEW_APP = 1,
  START_APP = 2,
  NOT_START_APP = 3
}

export enum StatusNoti {
  WAIT = 1,
  SUCCESS = 2,
  FAIL = 3
}

export interface PramsGetListNoti {
  app_id: string
  status?: StatusNoti
  per_page: number
  page: number
}

export interface ResponeNotify {
  id: number
  app_magazine_id: number
  type: 1 | 2
  content: string
  os_type: OS_TYPE
  condition: ConditionDevice
  conditions_day: number
  schedule_at: string,
  status: number,
  status_android: number,
  status_ios: number,
  total_status: number
}

export interface DeviceNotificationParamsType {
  condition?: number
  conditions_day?: number
  schedule?: string
  app_id?: string
}
